<template>
  <div class="main-wrapper" :class="{ expanded: getExpandedDashboardValue }">
    <div class="background"></div>
    <the-snackbar></the-snackbar>
    <v-layout row fill-height>
      <v-flex shrink pa-0>
        <the-vertical-menu :bigTop="getExpandedDashboardValue"></the-vertical-menu>
      </v-flex>
      <v-flex pa-0>
        <slot></slot>
      </v-flex>
    </v-layout>

    <the-footer class="footer"></the-footer>
  </div>
</template>

<script>
import store from '@/store';
import TheVerticalMenu from '@/components/TheVerticalMenu.vue';
import TheSnackbar from '@/components/TheSnackbar.vue';
import TheFooter from '@/components/TheFooter';

export default {
  components: {
    TheVerticalMenu,
    TheSnackbar,
    TheFooter
  },
  data() {
    return {
      expdandedDashboard: false
    };
  },
  computed: {
    getExpandedDashboardValue() {
      return this.$store.getters.getExpdandedDashboardValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  padding-bottom: 50px;
  height: 100%;
  position: relative;
  .background {
    position: absolute;
    z-index: 12;
    background: linear-gradient(360deg, #0a2b5a 0%, #154281 100%);
    border-bottom-left-radius: 35px;
    height: 200px;
    width: 100%;
  }
  &.expanded {
    .background {
      height: 290px;
    }
  }
}
.footer {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
}
</style>
